/**
 * Layout base do Dashboard
 */

import React from 'react';
import { Link } from 'react-router-dom';
import './DashboardLayout.css';

function DashboardLayout({ children, titulo = 'Dashboard Operacional' }) {
  return (
    <div className="dashboard-layout">
      <header className="dashboard-header">
        <div className="dashboard-header-content">
          <Link to="/" className="dashboard-back-link">
            ← Voltar ao Mapa
          </Link>
          <h1 className="dashboard-titulo">{titulo}</h1>
        </div>
      </header>
      <main className="dashboard-main">
        {children}
      </main>
    </div>
  );
}

export default DashboardLayout;
